import Swiper from "swiper";

import { Navigation, EffectFade, FreeMode, Keyboard } from "swiper/modules";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/keyboard";

class EventFeed {
    constructor(element) {
        // Class properties.
        this.carouselEl = element;

        this.howManyItems = this.carouselEl.dataset.howManyItems
            ? Number(this.carouselEl.dataset.howManyItems)
            : 0;

        let maxWidth = this.carouselEl.dataset.mobileBreakpoint ?? "576px";
        this.isMobile = window.matchMedia(`(max-width: ${maxWidth})`).matches;

        this.nextBtn = this.carouselEl.querySelector(".swiper-button-next");

        this.prevBtn = this.carouselEl.querySelector(".swiper-button-prev");

        this.createCarousel();

        this.handleButtonsVis();
    }

    createCarousel() {
        this.openingTimesCarousel = new Swiper(this.carouselEl, {
            modules: [Navigation, Keyboard, FreeMode],
            speed: 1000,
            slidesPerView: 1, // Mobile
            spaceBetween: 20,
            grabCursor: true,
            containerRole: `region`,
            navigation: {
                nextEl: this.nextBtn,
                prevEl: this.prevBtn,
            },
            breakpoints: {
                // Desktop.
                576: {
                    slidesPerView: 2,
                },
            },
        });
    }

    handleButtonsVis() {
        if (this.isMobile && this.howManyItems == 1) {
            this.nextBtn?.setAttribute("aria-hidden", true);
            this.prevBtn?.setAttribute("aria-hidden", true);
        } else if (!this.isMobile && this.howManyItems <= 2) {
            this.nextBtn?.setAttribute("aria-hidden", true);
            this.prevBtn?.setAttribute("aria-hidden", true);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const eventCarousels = document.querySelectorAll(
        `[data-carousel="event-feed"]`,
    );

    if (eventCarousels.length) {
        eventCarousels.forEach((element) => {
            new EventFeed(element);
        });
    }
});

export default EventFeed;
